export type BatchReasonSeverity = "warning" | "error" | "default"

export interface BatchReasonView {
  label: string
  severity: BatchReasonSeverity
}

const DICT_PREFIX = "dictionary-empty:"

/** kind словаря из reason `dictionary-empty:<kind>`, иначе null. */
export const dictionaryEmptyKind = (reason: string | null): string | null =>
  reason && reason.startsWith(DICT_PREFIX)
    ? reason.slice(DICT_PREFIX.length) || null
    : null

const REASON_LABELS: Record<string, BatchReasonView> = {
  "client-not-eligible": {
    label: "Клиент не готов (нет активной авторизованной сессии)",
    severity: "warning",
  },
  "launch-failed": { label: "Не удалось запустить цепочку", severity: "error" },
  cancelled: { label: "Отменено", severity: "default" },
  "chain-failed": { label: "Цепочка упала", severity: "error" },
  "already-has-spare": {
    label: "У аккаунта уже есть запасная сессия",
    severity: "warning",
  },
  "no-active-primary": {
    label: "Нет активной основной сессии (некому читать код)",
    severity: "warning",
  },
  "no-spare-slot": {
    label: "Слот запаски занят (параллельный запуск)",
    severity: "error",
  },
  "username-exhausted": {
    label: "Кандидаты юзернейма исчерпаны",
    severity: "warning",
  },
}

/**
 * Метка причины batch-item (спека §6). Неизвестные коды сервера
 * отображаются raw-строкой — UI не ломается.
 */
export const describeBatchReason = (reason: string | null): BatchReasonView => {
  if (!reason) return { label: "—", severity: "default" }
  const known = REASON_LABELS[reason]
  if (known) return known
  const kind = dictionaryEmptyKind(reason)
  if (kind !== null) {
    return { label: `Пустой словарь: ${kind}`, severity: "error" }
  }
  return { label: reason, severity: "default" }
}
